import React from 'react'
import { FloatingPortal, FloatingFocusManager } from '@floating-ui/react'

export const PopoverWrapper = ({ context, isPopover, children }) => {
  if (isPopover) {
    return (
      <FloatingPortal>
        <FloatingFocusManager
          context={context}
          modal={false}
          initialFocus={-1}
          closeOnFocusOut={false}
        >
          {children}
        </FloatingFocusManager>
      </FloatingPortal>
    )
  }

  return <FloatingPortal>{children}</FloatingPortal>
}
